import { GET, POST, PUT, DELETE } from "../utils/restUtils";
import { Auth } from "aws-amplify";
import _ from "lodash";

const getToken = async () => {
  let session = await Auth.currentSession();
  return session.getIdToken().getJwtToken();
};

export const getQuestions = async () => {
  let token = await getToken();
  return await GET("/questions", {
    headers: {
      Authorization: token
    }
  });
};

export const addQuestion = async (body, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  return POST("/questions", body, config);
};

export const getOneQuestion = async (urlParams, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  if (!urlParams.id) return new Error("id is required!");
  else return GET(`/questions/${urlParams.id}`, config);
};

export const updateQuestion = async (urlParams, params, data, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  const path = `/questions/${urlParams.id}?type=${params.type}`;

  if (!urlParams.id) return new Error("id is required!");
  else return PUT(path, data, config);
};

export const getShootQuestions = async (urlParams, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/questions`;

  if (!urlParams.clinic && !urlParams.created_at) return new Error("clinic and created_at are required");
  else return GET(path, config);
};

export const getUnselectedQuestions = async (urlParams, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/questions?unselected=1`;

  if (!urlParams.clinic && !urlParams.created_at) return new Error("clinic and created_at are required");
  else return GET(path, config);
};

export const addQuestionsToShoot = async (urlParams, data, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/questions`;

  if (!urlParams.clinic && !urlParams.created_at) return new Error("clinic and created_at are required");
  else return POST(path, data, config);
};

export const removeOneQuestionFromShoot = async (urlParams, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers });
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/questions/${urlParams.id}`;

  if (!urlParams.clinic && !urlParams.created_at && !urlParams.id)  return new Error("clinic, created_at and id are required");
  else return DELETE(path, config);
};

export const removeQuestionsFromShoot = async (urlParams, data, config) => {
  let token = await getToken();
  let headers = {
    Authorization: token
  };
  config = _.assign({}, config, { headers, data });
  const path = `/shoot/${urlParams.clinic}/${urlParams.created_at}/questions`;

  if (!urlParams.clinic && !urlParams.created_at) return new Error("clinic and created_at are required");
  else return DELETE(path, config);
};


export default {
  getQuestions,
  addQuestion,
  getOneQuestion,
  updateQuestion,
  getShootQuestions,
  addQuestionsToShoot,
  removeOneQuestionFromShoot,
  removeQuestionsFromShoot
};
